module.exports = __webpack_public_path__ + "static/media/P1_start.9981f632.png";